import { useState } from "react";
import OrderService from "../service/OrderService";

const useConfirmTransferRegisterUser = ({ onError, onSuccess } = {}) => {
  const [loadingConfirmTransfer, setLoadingConfirmTransfer] = useState(false);

  const productService = new OrderService();

  const confirmTransfer = async ({ idorder }) => {
    setLoadingConfirmTransfer(true);
    try {
      let resTransfers = await productService.confirmTransferRegisterUser({
        idorder,
        username: localStorage.getItem("__extraconomy_username"),
      });

      if (onError && resTransfers.messageCode !== 200000) {
        onError(resTransfers.messageCode);
      } else {
        if (onSuccess) onSuccess(resTransfers.result);

        return resTransfers.result;
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoadingConfirmTransfer(false);
    }
  };

  return {
    loadingConfirmTransfer,
    confirmTransfer,
  };
};

export default useConfirmTransferRegisterUser;
